import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";

import { store } from "./state/store";
import GlobalStyles from "./styles/GlobalStyles";
import Routing from "./Routing";

const container = document.getElementById("root");
const root = createRoot(container!);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <GlobalStyles />
      <Routing />
    </Provider>
  </React.StrictMode>
);
